/**
 * Remembers that the admin closed the "needs attention" banner.
 *
 * The rule is per sign-in: once it is closed it stays closed everywhere in that
 * session — other tabs, other pages, after a reload — and comes back the next
 * time somebody signs in, until the problem is actually fixed. The bell and the
 * System Alerts page are never affected; this only hides the dashboard strip.
 *
 * Hence localStorage rather than sessionStorage: sessionStorage is per *tab*, so
 * opening the app in a second tab would have shown the banner again inside the
 * same sign-in. The flag is cleared on logout (and when the login screen is
 * reached, which covers a session that expired instead of being logged out), so
 * a new sign-in always starts with the banner visible.
 *
 * Keying it by auth token was tried first and does not work here: this install
 * hands back the same token on every login, so the key never changed.
 */
const KEY = 'hf_system_alert_banner_hidden';

export function isBannerHidden() {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch (e) {
    return false;
  }
}

export function hideBanner() {
  try {
    localStorage.setItem(KEY, '1');
  } catch (e) {
    // Private-browsing modes can refuse localStorage. The banner still hides for
    // this page view; it just comes back on the next one.
  }
}

/** Called on sign-out and on the login screen, so the next sign-in sees it. */
export function resetBanner() {
  try {
    localStorage.removeItem(KEY);
  } catch (e) {
    // Nothing to do — if storage is unavailable nothing was stored either.
  }
}



// WEBPACK FOOTER //
// ./src/utils/systemAlertBanner.js